import { jsx as C } from "react/jsx-runtime";
import { useState as l, useCallback as P, useMemo as x, useEffect as y, useLayoutEffect as H } from "react";
import "../../../node_modules/@perxis-auto/shared/lib/lib/async/hooks/useAsync.js";
import "../../../node_modules/markdown-it/lib/rules_core/state_core.js";
import "../../../node_modules/markdown-it/lib/rules_block/state_block.js";
import "../../../node_modules/markdown-it/lib/rules_block/html_block.js";
import "../../../node_modules/markdown-it/lib/rules_inline/state_inline.js";
import "../../../node_modules/markdown-it/lib/rules_inline/escape.js";
import { usePrevState as E } from "../../../node_modules/@perxis-auto/shared/lib/lib/react/hooks/usePrevious.js";
import { useApp as b, useConfig as j, useCurrentStage as k } from "@perxis-auto/trade-in-sdk";
import { AppContext as w } from "../../../shared/lib/app/context/appContext.js";
import { withTradeInProvider as F } from "../../../shared/lib/app/hoc/withTradeInProvider.js";
function L({ apiRoot: e, clientId: o, children: v }) {
  const {
    actions: { reset: u }
  } = b(), { actions: g } = j(), { setApiRoot: c, setClientId: m } = g, { data: t } = k(), r = E(t), [s, n] = l([]), [A, S] = l({}), { onSuccess: a, onFailure: f, onReset: i } = A, d = P(() => (u(), n([]), i == null ? void 0 : i()), [i, u]), h = x(
    () => ({
      apiRoot: e,
      clientId: o,
      prevStage: s.length ? s[s.length - 1] : null,
      onSuccess: a,
      onFailure: f,
      onReset: d,
      setAppHandlers: S
    }),
    [e, o, d, s, f, a]
  );
  return y(() => {
    if (!t) {
      n([]);
      return;
    }
    if (!(!r || r.id === t.id)) {
      if (r.success === t.id || r.error === t.id || r.go_to === t.id) {
        n((p) => [...p, r]);
        return;
      }
      n((p) => p.slice(0, -1));
    }
  }, [t == null ? void 0 : t.id]), H(() => {
    c(e), m(o);
  }, [e, o, c, m]), /* @__PURE__ */ C(w.Provider, { value: h, children: v });
}
const O = F(L);
export {
  O as AppProvider
};
